<template>
    <div class="flex-1">
        <connect-app
            ref="connectApp"
            :app="app"
            :apis="$url.company.integration.external"
            :connect-function="connectFunc"
            @disconected="handleDisconnect">
            <template #logo>
                <div class="text-center text-2xl font-bold h-20">
                    HWL-CRM
                </div>
            </template>
        </connect-app>
        <hts-modal
            :show="dialog"
            title="HWL-CRM">
            <hts-form-input
                v-model="username"
                label="username" />
            <hts-form-input
                v-model="password"
                label="password" />
            <hts-form-button
                class="mt-2"
                color="primary"
                :loading="confirmed"
                @click="confirmConnect">
                {{ $t('labels.save') }}
            </hts-form-button>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
import ConnectApp from '../app.vue'
const app = ref('hwl-crm')
const connectApp = ref<any>(null)
const dialog = ref(false)
const confirmed = ref(false)
const username = ref('')
const password = ref('')
const connectFunc = async () => {
  dialog.value = true
  confirmed.value = false
  const result = await new Promise((resolve) => {
    const tmpInt = setInterval(() => {
      if (confirmed.value) {
        clearInterval(tmpInt)
        confirmed.value = false
        dialog.value = false
        resolve({
          username: username.value,
          password: password.value
        })
      }
    }, 300)
  })
  return result
}

const confirmConnect = () => {
  confirmed.value = true
}

const handleDisconnect = () => {}
</script>
